module.exports = __webpack_public_path__ + "static/8bd20d82e30650fdca9e4b39637f0042cfee4b6c2e4e4c2f7cca6d6913a934e0-b5836fcce67b69bce275048f2fc051a8.png";